
const setSubDomain = (context,sub_domain) => {
	context.commit('SET_SUB_DOMAIN', sub_domain)
}

const setEvent = (context,event) => {
	context.commit('SET_EVENT', event)
}

const setLog = (context,log) => {
	context.commit('SET_LOG', log)
}

const setLocation = (context,location) => {
	context.commit('SET_LOCATION', location)
}

const setRequest = (context,request) => {
	context.commit('SET_REQUEST', request)
}

const setNavigation = (context, navigation) => {
	context.commit('SET_NAVIGATION', navigation)
}

const setEnv = (context, env) => {
	context.commit('SET_ENV', env)
}

const setUrlApi = (context, url_api) => {
	context.commit('SET_URL_API', url_api)
}

const setPcmso = (context, pcmso) => {
	context.commit('SET_PCMSO', pcmso)
}

const setWindow = (context, window) => {
	context.commit('SET_WINDOW', window);

	var device = 'lg';

	if(window.width>=1200){
		device = 'lg';
	}
	else if(window.width >= 992) {
		device = 'md';
	}
	else if (window.width >= 785) {
		device = 'sm';
	}
	else{
		device = 'xs';
	}

	context.commit('SET_DEVICE', device);
}

export{
	setSubDomain,
	setLog,
	setLocation,
	setRequest,
	setNavigation,
	setEnv,
	setWindow,
	setEvent,
	setPcmso
}



// WEBPACK FOOTER //
// ./src/store/common/actions.js